export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let file = null;
  try {
    file = new File([u8arr], filename, { type: mime });
  } catch (e) {
    const File = class File extends Blob {
      lastModifiedDate;
      lastModified;
      name
      constructor(chunks, filename, opts = {}) {
        super(chunks, opts)
        this.lastModifiedDate = new Date();
        this.lastModified = + this.lastModifiedDate;
        this.name = filename
      }
    }
    file = new File([u8arr], filename, { type: mime });
  }
  return file;
}

export function removeNullOrEmpty(input: any) {
  const dataProperty = Object.assign({}, input);
  for (const key in dataProperty) {
    if (dataProperty[key] === null || typeof dataProperty[key] === 'object' || dataProperty[key] === "") {
      delete dataProperty[key];
    }
  }
  return dataProperty
}

export function compareWithKeys(objectA: any, objectB: any, keys: string[]): boolean {
  let isChange = false;
  keys.every(key => {
    if (objectA[key] === objectB[key]) {
      return true;
    }
    isChange = true;
    return false;
  })

  return isChange;
}

export function objectKeyModifier(objectA: any, objectB: any, keys: string[]): string[] {
  let fieldChange: string[] = [];
  keys.map(key => {
    if ((objectA[key] && objectB[key]) && objectA[key] !== objectB[key]) {
      fieldChange.push(key);
    }
  })
  return fieldChange;
}

class lineInterect {
  // Given three collinear points p, q, r, the function checks if
  // point q lies on line segment 'pr'
  onSegment(p, q, r) {
    if (q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) &&
      q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y))
      return true;

    return false;
  }

  // To find orientation of ordered triplet (p, q, r).
  // The function returns following values
  // 0 --> p, q and r are collinear
  // 1 --> Clockwise
  // 2 --> Counterclockwise
  orientation(p, q, r) {

    // See https://www.geeksforgeeks.org/orientation-3-ordered-points/
    // for details of below formula.
    let val = (q.y - p.y) * (r.x - q.x) -
      (q.x - p.x) * (r.y - q.y);

    if (val == 0) return 0; // collinear

    return (val > 0) ? 1 : 2; // clock or counterclock wise
  }

  // The main function that returns true if line segment 'p1q1'
  // and 'p2q2' intersect.
  isOverlap(p1, q1, p2, q2) {

    // Find the four orientations needed for general and
    // special cases
    let o1 = this.orientation(p1, q1, p2);
    let o2 = this.orientation(p1, q1, q2);
    let o3 = this.orientation(p2, q2, p1);
    let o4 = this.orientation(p2, q2, q1);

    // General case
    if (o1 != o2 && o3 != o4)
      return true;

    // Special Cases
    // p1, q1 and p2 are collinear and p2 lies on segment p1q1
    if (o1 == 0 && this.onSegment(p1, p2, q1)) return true;

    // p1, q1 and q2 are collinear and q2 lies on segment p1q1
    if (o2 == 0 && this.onSegment(p1, q2, q1)) return true;

    // p2, q2 and p1 are collinear and p1 lies on segment p2q2
    if (o3 == 0 && this.onSegment(p2, p1, q2)) return true;

    // p2, q2 and q1 are collinear and q1 lies on segment p2q2
    if (o4 == 0 && this.onSegment(p2, q1, q2)) return true;

    return false; // Doesn't fall in any of the above cases
  }

  distance(p1, p2) {
    var a = p1.x - p2.x;
    var b = p1.y - p2.y;

    return Math.sqrt(a * a + b * b);
  }
}

export const lineHelp = new lineInterect();

export function pointInPolygonNested(point, vs, start = undefined, end = undefined) {
  var x = point[0], y = point[1];
  var inside = false;
  if (start === undefined) start = 0;
  if (end === undefined) end = vs.length;
  var len = end - start;
  for (var i = 0, j = len - 1; i < len; j = i++) {
    var xi = vs[i + start][0], yi = vs[i + start][1];
    var xj = vs[j + start][0], yj = vs[j + start][1];
    var intersect = ((yi > y) !== (yj > y))
      && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }
  return inside;
};

export function pointInCircel(x, y, circle_x, circle_y, rad) {
  return ((x - circle_x) * (x - circle_x) + (y - circle_y) * (y - circle_y) <= rad * rad);
}